export default function setNotes(data) {
    return {
        type: "setNotes",
        data,
    };
}
